import { http } from 'services'
// initial state
const state = () => ({
  all: [],
  errors: null
})

// getters
const getters = {
}

// actions
const actions = {
  ['timezones.getAll'] ({ commit, state }) {
    commit('CLEAR_ERRORS')

    if (state.all.length) {
      return commit('GET_ALL_TIMEZONES');
    }

    return (http.get('timezones?_all=true')).then ((res) => {
      commit('GET_ALL_TIMEZONES', res);
    })
    .catch ((res) => {
      commit('timezones_ERROR', res);
    })
  },

}

// mutations
const mutations = {

  GET_ALL_TIMEZONES (state, res) {
    if(res)
      state.all = res.data
  },

  //ERRORS
  TIMEZONES_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
